import React from 'react';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';
import { ServerCommunicationUtil } from '../../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const FullscreenCustomListTitle = createReactClass({
  getInitialState() {
    return {
      editing: false,
      saving: false,
      newListTitle: this.props.list ? this.props.list.title : null,
      errorMsg: null
    };
  },
  handleEditClick() {
    this.setState({ editing: !this.setState.editing });
  },
  handleCancelClick() {
    const newListTitle = this.props.list ? this.props.list.title : null;
    this.setState({ newListTitle, errorMsg: null, editing: false });
  },
  handleDeleteClick() {
    if (!confirm(StringConstantsMixin.strings.DELETE_LIST_QUESTION)) return;
    const url = `/api/alltrails/lists/${this.props.list.id}`;
    ServerCommunicationUtil.deleteApiEndpoint(url, {}, this.handleDeleteSuccess, this.handleDeleteError, this.handleDeleteComplete);
    this.setState({ saving: true });
  },
  handleDeleteSuccess() {
    window.location = LanguageSupportUtil.wrapUrlSafe('/explore');
  },
  handleDeleteError() {
    this.setState({ errorMsg: StringConstantsMixin.strings.ERR_TRY_AGAIN });
  },
  handleDeleteComplete() {},
  handleSaveClick() {
    this.setState({ saving: true });
    if (this.props.list) {
      const url = `/api/alltrails/lists/${this.props.list.id}`;
      // Use name due to API fields consistency
      ServerCommunicationUtil.putApiEndpoint(
        url,
        { name: this.state.newListTitle },
        this.handleSaveSuccess,
        this.handleSaveError,
        this.handleSaveComplete
      );
    }
  },
  handleSaveSuccess(data) {
    // only saves title
    this.setState({ saving: false, editing: false });
    if (this.props.list) {
      const newListTitle = data.lists[0].name;
      const newSlug = data.lists[0].slug;
      this.props.handleListTitleUpdate(newListTitle, newSlug);
      window.location.href = LanguageSupportUtil.wrapUrlSafe(`/explore/list/${newSlug}`);
    } else {
      window.location.reload();
    }
  },
  handleSaveError() {
    this.setState({ saving: false, errorMsg: StringConstantsMixin.strings.ERR_TRY_AGAIN });
  },
  handleSaveComplete() {},
  handleListKeyUp(e) {
    if (e.keyCode == 13) {
      this.handleSaveClick();
      return false;
    }
  },
  handleListTitleChange(e) {
    this.setState({ newListTitle: e.target.value });
  },
  render() {
    const listTitleClasses = `list-title ${StringConstantsMixin.constants.XLATE.NONE}`;
    if (this.props.list) {
      let editButtonsSpan = null;
      if (this.state.editing && this.state.errorMsg) {
        editButtonsSpan = (
          <span className="edit-buttons">
            <span className="link" onClick={this.handleCancelClick}>
              {StringConstantsMixin.strings.CANCEL}
            </span>
          </span>
        );
      } else if (this.state.editing && !this.state.saving) {
        editButtonsSpan = (
          <span className="edit-buttons">
            <span className="btn simple btn-slim blue" onClick={this.handleSaveClick}>
              {StringConstantsMixin.strings.SAVE}
            </span>
            <span className="link" onClick={this.handleCancelClick}>
              {StringConstantsMixin.strings.CANCEL}
            </span>
            <span className="simple btn btn-slim orange del" onClick={this.handleDeleteClick}>
              {StringConstantsMixin.strings.DELETE}
            </span>
          </span>
        );
      } else if (this.state.saving) {
        editButtonsSpan = (
          <span className="edit-buttons">
            <span>{StringConstantsMixin.strings.SAVING}</span>
          </span>
        );
      }
      if (this.props.canEdit) {
        if (this.state.editing && this.state.errorMsg) {
          return (
            <div className={listTitleClasses}>
              <input type="text" value={this.state.newListTitle} onChange={this.handleListTitleChange} onKeyUp={this.handleListKeyUp} />
              {editButtonsSpan}
              <span>{this.state.errorMsg}</span>
            </div>
          );
        }
        if (this.state.editing) {
          return (
            <div className={listTitleClasses}>
              <input type="text" value={this.state.newListTitle} onChange={this.handleListTitleChange} onKeyUp={this.handleListKeyUp} />
              {editButtonsSpan}
            </div>
          );
        }
        var expandButton = (
          <span className="floatright">
            <a className="expand" href={LanguageSupportUtil.wrapUrlSafe(`/lists/${this.props.list.slug}`)}>
              {StringConstantsMixin.strings.VIEW_LIST_DETAILS}
            </a>
          </span>
        );
        return (
          <div className={listTitleClasses}>
            <h1 className="result-title short-ellipsis" itemProp="name" title={this.props.list.title}>
              {this.props.list.title}
            </h1>
            <span className="link edit" onClick={this.handleEditClick}>
              {StringConstantsMixin.strings.EDIT}
            </span>
            {expandButton}
          </div>
        );
      }

      expandButton = (
        <span className="floatright">
          <a className="expand" href={LanguageSupportUtil.wrapUrlSafe(`/lists/${this.props.list.slug}`)}>
            {StringConstantsMixin.strings.VIEW_LIST_DETAILS}
          </a>
        </span>
      );
      return (
        <div className={listTitleClasses}>
          <h1 className="result-title long-ellipsis" title={this.props.list.title}>
            {this.props.list.title}
          </h1>
          {expandButton}
        </div>
      );
    }

    if (this.state.editing && this.state.errorMsg) {
      editButtonsSpan = (
        <span className="edit-buttons">
          <span className="link" onClick={this.handleCancelClick}>
            {StringConstantsMixin.strings.CANCEL}
          </span>
        </span>
      );
    } else if (this.state.editing && !this.state.saving) {
      editButtonsSpan = (
        <span className="edit-buttons">
          <span className="btn simple btn-slim blue" onClick={this.handleSaveClick}>
            {StringConstantsMixin.strings.SAVE}
          </span>
          <span className="link" onClick={this.handleCancelClick}>
            {StringConstantsMixin.strings.CANCEL}
          </span>
        </span>
      );
    } else if (this.state.saving) {
      editButtonsSpan = (
        <span className="edit-buttons">
          <span>{StringConstantsMixin.strings.SAVING}</span>
        </span>
      );
    }
    if (this.props.canEdit) {
      if (this.state.editing) {
        return (
          <div className={`${listTitleClasses} result-btn-box`}>
            <h1 className="result-title" title={this.props.builtInTitle}>
              {this.props.builtInTitle}
            </h1>
            {editButtonsSpan}
          </div>
        );
      }
      return (
        <div className={`${listTitleClasses} result-btn-box`}>
          <h1 className="result-title short-ellipsis" title={this.props.builtInTitle}>
            {this.props.builtInTitle}
          </h1>
          <span className="link edit" onClick={this.handleEditClick}>
            {StringConstantsMixin.strings.EDIT}
          </span>
          {editButtonsSpan}
        </div>
      );
    }
    return (
      <div className={listTitleClasses}>
        <h1 className="result-title" title={this.props.builtInTitle}>
          {this.props.builtInTitle}
        </h1>
      </div>
    );
  }
});

export { FullscreenCustomListTitle };
